import { messagesRoot } from "./constants";

class ApiReadSecureMessage {
  constructor(apiClass) {
    this.apiClass = apiClass;
  }

  callApi = async (messageId, mailbox) => {
    const apiRoute = messagesRoot + "ReadMessage";
    let params = {
      messageId: messageId,
      mailbox: mailbox
    };
    return await this.apiClass.CallApi("putQuery", apiRoute, params);
  };
}

export default ApiReadSecureMessage;
